import React, { useState, useEffect, useContext } from 'react';
import './academic.scss';
import TeamCarousel from '../../../../../components/Helpers/TeamCarousel';
import CurriculumContext from '../../../../../contexts/pages/curriculum/curriculumContext';

const AcademicArea = (props) => {
    const subjects = props.subjects || [];
    const { ibBachelor } = useContext(CurriculumContext) || {};

    // Extraer la información de CAS y su personal 100% desde Strapi
    const casPerson = subjects
        .flatMap(s => s?.tarjetas_personal || [])
        .find(p => p?.cargo?.toLowerCase()?.includes('cas') || p?.nombre?.toLowerCase()?.includes('licelot'));

    const casTroncal = ibBachelor?.troncales_ib?.find(
        t => t?.titulo?.toLowerCase()?.includes('cas') || t?.titulo?.toLowerCase()?.includes('creatividad')
    );

    const casSubject = {
        titulo: casTroncal?.titulo || 'CAS',
        descripcion: casTroncal?.descripcion || casTroncal?.contenido || '',
        tarjetas_personal: casPerson ? [casPerson] : []
    };

    const [subjectState, setSubjectState] = useState({
        titulo: '',
        descripcion: '',
        tarjetas_personal: []
    });

    useEffect(() => {
        if (subjects.length > 0 && !subjectState.titulo) {
            setSubjectState({
                titulo: subjects[0].titulo,
                descripcion: subjects[0].descripcion,
                tarjetas_personal: subjects[0].tarjetas_personal || []
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subjects.length, subjectState.titulo]);

    const handleSubjectState = (subject) => {
        setSubjectState({
            titulo: subject.titulo,
            descripcion: subject.descripcion,
            tarjetas_personal: subject.tarjetas_personal || []
        });
    };

    const isCasActive = subjectState.titulo === casSubject.titulo;

    return (
        <section className="academic-wrapper">
            <h1 className="subject-title">ÁREAS ACADÉMICAS</h1>

            {/* Selector de Asignaturas */}
            <div className="row-sub">
                {subjects.map((subject) => {
                    const isActive = subject.titulo === subjectState.titulo;
                    return (
                        <button
                            type="button"
                            key={subject.id || subject._id || subject.titulo}
                            className={`subjectTile ${isActive ? 'active' : ''}`}
                            onClick={() => handleSubjectState(subject)}
                        >
                            <span className="subjectTile-title">
                                {String(subject.titulo).toUpperCase()}
                            </span>
                        </button>
                    );
                })}

                {/* Última Card: CAS con el mismo diseño e integración de Strapi */}
                <button
                    type="button"
                    key="cas-subject-tile"
                    className={`subjectTile ${isCasActive ? 'active' : ''}`}
                    onClick={() => handleSubjectState(casSubject)}
                >
                    <span className="subjectTile-title">CAS</span>
                </button>
            </div>

            {/* Detalle del Área Seleccionada */}
            {subjectState.titulo && (
                <article className="personal-row">
                    <h2 className="personal-title">{subjectState.titulo}</h2>
                    <p className="personal-text">{subjectState.descripcion}</p>

                    {subjectState.tarjetas_personal && subjectState.tarjetas_personal.length > 0 && (
                        <div className="personal-carousel-wrapper">
                            <TeamCarousel items={subjectState.tarjetas_personal} />
                        </div>
                    )}
                </article>
            )}
        </section>
    );
};

export default AcademicArea;